import React, { Component,createRef } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { osName } from 'react-device-detect';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';

import { alertActions } from '../../actions';
import { commonConstant, OtpVerification } from '../../common';
import { customerService, activityService, utilsService } from '../../services';
import { Modal, OTPInputNew } from '../../helpers';
import { emptyOtpError, getOtp, submitOtp } from '../../actions/otpVerifcationAction';
import _, { last } from 'lodash';

class ChangeMID extends Component {
  constructor(props) {
    super(props);

    const customer = JSON.parse(sessionStorage.getItem('customer'));
    if (sessionStorage.getItem('customer') === null || sessionStorage.getItem('customer') === 'undefined') {
      window.location.replace(commonConstant.pathHome);
    }

    this.state = {
      customer: customer,
      birthday: '',
      distNum: '',
      loading: false,
      error: false,
      isOpenCalendar: false,
      isOpenModal: false,
      profile:'',
      invalid: false,
      invalidCount: 0,
      otpLoading:  true,
      initialLoading: true,
      isVerifyOTP: false,
      phoneNumber: '',
      countryCode: ''
    };

    this.otpRef = createRef();
  }

 async componentDidMount(){
    const { location } = this.props;
    if (!location?.state || !location?.state?.myMember) return window.location.replace(commonConstant.pathHome);
    const partyList = location?.state?.myMember && location?.state?.myMember?.partyList?.length && location?.state?.myMember?.partyList;

    const partyId = location?.state?.partyId || '';
    let selectedParty = null;
    let selectedPartyIndex = -1;
    let phoneList;

    if (partyList.length && partyId) {
      selectedPartyIndex = partyList.findIndex(party => party.partyMst?.partyId === partyId);
      selectedParty = partyList[selectedPartyIndex];
  }
    if (selectedParty && selectedParty.phoneList?.length) {
      phoneList = selectedParty.phoneList.find((list) => list?.phoneLocalNum?.trim() !== '' && list?.contactPointTypeCd === 'Mobile' && Array.isArray(list?.usageList) && list?.usageList.find((usage) => usage?.primaryFlag));
    }
    this.setState({ profile: location?.state?.myMember, oldLineId: location?.state?.oldLineId, oldMember: location?.state?.oldMember, phoneNumber: phoneList?.phoneLocalNum, countryCode: phoneList?.phoneCntryCd, selectedPartyIndex })
    if (phoneList) {
      this.props.otpFetch({
        context: `lbc-registration-${this.state.customer.uid}`,
        modeValue: `+${phoneList?.phoneCntryCd}${phoneList?.phoneLocalNum}`
      });
    }
  }

  onPaste = e => {
    e.preventDefault();
    return false;
  };

    async componentDidUpdate(prevProps){
        if (!isEqual(prevProps.otp,this.props.otp)){
          this.setState({
            otpLoading: false,
            initialLoading: false,
          });
        }
    if (this.props.otpError?.message === 'Invalid OTP' && !isEqual(prevProps.otpError, this.props.otpError)) {
      this.setState(state => ({
        loading: false,
        invalid: true,
        invalidCount: state.invalidCount + 1,
      }));
      this.props.emptyOtpError();
      this.otpRef.current.clear();
    } else if (!isEqual(prevProps.verifyOtp, this.props.verifyOtp)) {
      if (this.props.verifyOtp.success) {
        const { profile, oldLineId, oldMember, isVerifyOTP, selectedPartyIndex } = this.state;
            const amwayNumber = profile.accountMst.aboNum;
            if(profile && isVerifyOTP === false){
                this.state.isVerifyOTP = true;
          const date = new Date(profile.partyList[selectedPartyIndex].partyMst.birthdate);
                const convertYearBEtoAD = date.getFullYear();
                const month = date.getMonth() + 1;
                const monthWithZero = month <= 9 ? `0${month.toString()}` : month.toString();
                const day = date.getDate().toString();
                const dayWithZero = day <= 9 ? `0${day}` : day;
      
          const cleanData = profile?.partyList?.[selectedPartyIndex];
          const taxEntry = cleanData?.taxList?.[0];
          const cidKey = (taxEntry?.taxTypeCd === 'CID' && cleanData?.partyMst?.roleCd === 'BusinessOwner') ? taxEntry.taxId : '';
                
          const customer = {
            ...this.state.customer,
                  name: profile.accountMst.accountName,
                  amwayNumber: parseInt(amwayNumber),
            cid: cidKey ? cidKey.substr(-4) : null,
                  birthday: `${convertYearBEtoAD.toString()}-${monthWithZero}-${dayWithZero}`,
            partyId: profile.partyList[selectedPartyIndex].partyMst.partyId,
                  socialType: 'LINE',
                };
          if (customer) {
            sessionStorage.setItem('customer', JSON.stringify(customer));
                    if(oldMember && (oldMember.uid !== this.state.customer.uid)){
                      await utilsService.deleteUserFromRichmenu(oldLineId)
                        .then( () => {
                            activityService.create({
                            service: "customers",
                            action: "delete",
                            userId: oldMember._id,
                            uid: oldMember.uid,
                            data: oldMember,
                        })
                      });

                    }

                    return this.props.history.push(commonConstant.pathSuccess);
          }
        }
      }
          else {
            const { invalidCount } = this.state;
            // if (invalidCount < 2){
              this.setState(state => ({
                loading: false,
                invalid: true,
                invalidCount: state.invalidCount + 1,
              }));
              this.otpRef.current.clear();
            // } 
            // else {
            //   this.otpRef.current.clear();
            //   this.setState({
            //     isOpenModal: true,
            //   });
            // }
          }
        }
      }

    handleSubmitOtp = async (otp,props) => {
        const { isFilled } = props;
        if (isFilled){
          this.props.verifyOtpFetch({
            otp,
        challengeId: this.props.otp.challengeId
          });
          this.setState({ loading: true });
        }
      }
      
      handleFetchOtp = () => {
    try {
        this.setState({
            otpLoading: true,
        loading: true,
        invalid: false,
        });
      this.props.otpFetch({
        context: `lbc-registration-${this.state.customer.uid}`,
        modeValue: `+${this.state.countryCode}${this.state.phoneNumber}`
      });
    } catch (e) {
      this.setState({
        otpLoading: false
      });
      }
  }

    render() {
      const { handleSubmitOtp, handleFetchOtp } = this;
    const { isOpenModal, invalid, otpLoading, initialLoading, phoneNumber } = this.state;
      
      if(initialLoading){
        return <LoadingOverlay active={this.state.otpLoading} spinner text="Loading" styles={{ wrapper: { width: '100%', minHeight: '100%' } }} />
      }

      return (
      <div className="otp-verfication-container">
          {
            isOpenModal &&
            <Modal
            title="คุณกรอกรหัส OTP ผิดเกินกำหนด"
            content="กรุณาติดต่อ Amway Contact Center"
            type="warning"
            fnOk={() => window.location = 'tel:027258000'}
            fnCancel={() => this.props.history.replace(commonConstant.pathHome)}
            okText="โทร"
            cancleText="ยกเลิกรายการ" />
          }

        <OtpVerification headerImage={'/images/registration/AmwayLineBusinessConnectLogo.png'}
          imgContainerClass={''}
          headerText={'ยืนยันรหัส OTP'}
          otpText={'หมายเลข OTP จะถูกส่งไปยังหมายเลข'}
          phoneNumber={phoneNumber}
          footerText={'ระบบจะทำการเปลี่ยนบัญชี LINE ของท่าน\nเมื่อทำการยืนยันตัวตนผ่านเบอร์โทรศัพท์เสร็จสมบูรณ์'}
        >
          <OTPInputNew
                loading={otpLoading} 
                ref={this.otpRef} 
                invalid={invalid} 
            count={6}
                onChange={invalid ? () => this.setState({ invalid: false }) : null} 
                onLastInput={(val,props) => handleSubmitOtp(val,props)}
                resendFn={handleFetchOtp}
                resendBtn={true}
                delay={true}
                resendDelay={60}
                invalidMessage="รหัส OTP ไม่ถูกต้องกรุณาลองอีกครั้ง"
              />
        </OtpVerification>
        {
          initialLoading && <LoadingOverlay active={this.state.otpLoading} spinner text="Loading" styles={{ wrapper: { width: '100%', minHeight: '100%' } }} />
        }
              </div>
      );
    }
}

const mapStateToProps = ({ otpVerification }) => ({
  otp: otpVerification.otpData,
  verifyOtp: otpVerification.submitData,
  otpError: otpVerification.error
  });

const  mapDispatchToProps = (dispatch) => ({
    showError: (message) => dispatch(alertActions.showError(message)),
  otpFetch: payload => dispatch(getOtp(payload)),
  verifyOtpFetch: payload => dispatch(submitOtp(payload)),
  emptyOtpError: () => dispatch(emptyOtpError())
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangeMID);
